<template>
    <div class="pop_overlay_black" v-if="isShow">
        <div class="pop_wrap rsv2_manager_set_pop" style="width: 680px; height: 824px;">
            <div v-if="isLoading" class="loading_bg" style="z-index: 999;">
                <div class="loading_wrap">
                    <div class="loading_obj">
                        <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66"
                             xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33"
                                    r="30"></circle>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="pop_title">
                <span class="title">{{ $t('reservation_settings.popup_staff_settings.title') }}</span>
                <button class="mgl_auto" @click="action_Close">
                    <v-icon large>mdi-close</v-icon>
                </button>
            </div>
            <ul class="pop_tab_wrap">
                <li :class="{'on': isAppReservationSettingTab == false}" @click="action_ChangeTab(false)">
                    <a>
                        {{ $t('reservation_settings.popup_staff_settings.label_tab_basic_setting') }}
                    </a>
                </li>
                <li :class="{'on': isAppReservationSettingTab == true}" @click="action_ChangeTab(true)">
                    <a>
                        {{ $t('reservation_settings.popup_staff_settings.label_tab_app_appointment_setting') }}
                    </a>
                </li>
            </ul>
            <div class="pop_cont">
                <!-- 기본 설정 -->
                <DefaultSetting
                    v-if="!isAppReservationSettingTab"
                    :column="column"
                    :users="users"
                    :programs="programs"
                    :employees="employees"
                    :isErrorTitle="isErrorTitle"
                    :isErrorDuplicatedTitle="isErrorDuplicatedTitle"
                    :isErrorSelectedProgram="isErrorSelectedProgram"
                    :isErrorBoldTime="isErrorBoldTime"
                    :isErrorDuplicatedBoldTime="isErrorDuplicatedBoldTime"
                    @updateValue="updateValue"
                    @clearError="clearError"
                />
                <!-- 앱 예약 설정 -->
                <AppReservationSetting
                    v-if="isAppReservationSettingTab"
                    :column="column"
                    :isErrorAppInterval="isErrorAppInterval"
                    :isErrorDuplicatedAppInterval="isErrorDuplicatedAppInterval"
                    @updateValue="updateValue"
                    @clearError="clearError"
                />
            </div>
            <!-- 버튼 영역 -->
            <div class="btn_wrap relative">
                <span class="abs_left pdlr_20">
                    <button class="btn_underline dgray_txt" v-if="!isCreate" @click="action_Remove">
                        <v-icon small>mdi-trash-can-outline</v-icon>
                        {{ $t('reservation_settings.popup_staff_settings.label_delete_staff') }}
                    </button>
                </span>
                <button class="btn btn_l btn_dgray" @click="action_Close">{{ $t('common.cancel') }}</button>
                <button class="btn btn_l btn_blue" @click="action_Save" :disabled="isEmptyProgram">{{ $t('common.save') }}</button>
            </div>
        </div>
    </div>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
import { typeToString } from '@/util/type-to-string'
import DefaultSetting from './DefaultSetting/DefaultSetting.vue'
import AppReservationSetting from './AppReservationSetting/AppReservationSetting.vue'

import { closeAlertPopup, showAlertPopup } from '../../../sheet-alert'
import { hideColumnSetting, sheetOverlays } from '../../../sheet-overlays'
import { sheetFilters, saveColumns } from '../../../sheet-filters'
import { useQueryClient } from '@tanstack/vue-query'
import { isApiErrorWithCode } from '@/apis/instances/check-api-response'
import { v2EmployeeListQueryOptions } from '@/composables/queries/v2employee/use-v2-employee-find-query'
import { v2ReservationProgramListQueryOptions } from '@/composables/queries/v2reservationprogram/use-v2-reservationprogram-find-query'
import { hospitalAccountFindQueryOptions } from '@/composables/queries/hospitalaccount/use-hospital-account-find-query'
import { reservationColumnFindQueryOptions } from '@/composables/queries/reservationcolumn/use-reservation-column-find-query'
import { useV2ReservationColumnCreateMutation } from '@/composables/queries/v2reservationcolumn/use-v2-reservationcolumn-create-mutation'
import { useV2ReservationColumnUpdateMutation } from '@/composables/queries/v2reservationcolumn/use-v2-reservationcolumn-update-mutation'
import { useV2ReservationColumnRemoveMutation } from '@/composables/queries/v2reservationcolumn/use-v2-reservationcolumn-remove-mutation'

export default {
    setup() {
        const queryClient = useQueryClient()
        const { mutateAsync: createReservationColumn } = useV2ReservationColumnCreateMutation()
        const { mutateAsync: updateReservationColumn } = useV2ReservationColumnUpdateMutation()
        const { mutateAsync: removeReservationColumn } = useV2ReservationColumnRemoveMutation()
        return { queryClient, createReservationColumn, updateReservationColumn, removeReservationColumn }
    },
    components: { DefaultSetting, AppReservationSetting },
    data() {
        return {
            isLoading: false,

            sheetOverlays,

            sheetFilters,

            users: [],
            programs: [],
            employees: [],
            column: {},

            isErrorTitle: false,
            isErrorDuplicatedTitle: false,
            isErrorSelectedProgram: false,
            isErrorBoldTime: false,
            isErrorDuplicatedBoldTime: false,
            isErrorAppInterval: false,
            isErrorDuplicatedAppInterval: false,

            isAppReservationSettingTab: false
        }
    },
    watch: {
        isShow: {
            handler: function (newValue) {
                if (newValue != true) {
                    return
                }
                this.isAppReservationSettingTab = false

                this.column = deepCopy(this.sheetOverlays.selectedColumn)
                if (this.column.notificationUsers != undefined && this.column.notificationUsers.length > 0) {
                    if (typeToString(this.column.notificationUsers[0]) == 'object') {
                        this.column.notificationUsers = this.column.notificationUsers.map(u => u._id)
                    }
                }
                this.column.notificationUsers = this.column.notificationUsers ?? []
                this.column.programs = this.column.programs ?? []
                this.column.appPrograms = this.column.appPrograms ?? []
                this.column.boldInterval = this.column.boldInterval ?? 60
                this.column.boldTimeIntervals = this.column.boldTimeIntervals ?? []
                this.column.sameDayBlockDuration = this.column.sameDayBlockDuration ?? 0
                this.column.sameDayBlockType = this.column.sameDayBlockType ?? 'day'
                this.column.possibleCreateRange = this.column.possibleCreateRange ?? 14
                this.column.canCreateType = this.column.canCreateType ?? 'day'
                this.column.canModify = this.column.canModify ?? false
                this.column.canModifyType = this.column.canModifyType ?? 'day'
                this.column.possibleModifyRange = this.column.possibleModifyRange ?? 1
                this.column.canCancel = this.column.canCancel ?? false
                this.column.canCancelType = this.column.canCancelType ?? 'day'
                this.column.possibleCancelRange = this.column.possibleCancelRange ?? 1
                this.column.usingDefaultAppInterval = this.column.usingDefaultAppInterval ?? true
                this.column.appInterval = this.column.appInterval ?? 60
                this.column.appTimeIntervals = this.column.appTimeIntervals ?? []
                this.column.appMaxCapacity = this.column.appMaxCapacity ?? 1

                this.column = deepCopy(this.column)

                this.isErrorTitle = false
                this.isErrorDuplicatedTitle = false
                this.isErrorSelectedProgram = false
                this.isErrorBoldTime = false
                this.isErrorDuplicatedBoldTime = false
                this.isErrorAppInterval = false
                this.isErrorDuplicatedAppInterval = false

                this.loadData()
            }
        }
    },
    computed: {
        isShow: function () {
            return this.sheetOverlays.isShowColumnSetting
        },
        isEmptyProgram: function () {
            return this.column.programs == undefined || (this.column.programs?.length ?? 0) == 0
        },
        isCreate: function () {
            return this.column._id == undefined
        }
    },
    methods: {
        // MARK: - 
        async validate() {
            if (this.column.title == undefined || this.column.title == '') {
                this.isErrorTitle = true
            }
            if (this.column.programs.length == 0) {
                this.isErrorSelectedProgram = true
            }
            if (await this.isDuplicatedColumnTitle() == true) {
                this.isErrorDuplicatedTitle = true
            }
            if (this.column.usingDefaultBoldInterval == false) {
                if (this.column.boldTimeIntervals.length == 0) {
                    this.isErrorBoldTime = true
                } else {
                    if (this.isDuplicateTimes(this.column.boldTimeIntervals)) {
                        this.isErrorDuplicatedBoldTime = true
                    }
                }
            } else {
                this.column.boldTimeIntervals = []
            }
            if (this.column.usingDefaultAppInterval == false) {
                if (this.column.appTimeIntervals.length == 0) {
                    this.isErrorAppInterval = true
                } else {
                    if (this.isDuplicateTimes(this.column.appTimeIntervals)) {
                        this.isErrorDuplicatedAppInterval = true
                    }
                }
            } else {
                this.column.appTimeIntervals = []
            }

            return !this.isErrorTitle && !this.isErrorDuplicatedTitle && !this.isErrorSelectedProgram && !this.isErrorBoldTime && !this.isErrorDuplicatedBoldTime && !this.isErrorAppInterval && !this.isErrorDuplicatedAppInterval
        },
        async isDuplicatedColumnTitle() {
            const groupID = typeToString(this.column.groupID) == 'object' ? this.column.groupID._id : this.column.groupID
            let sameTitleColumns
            try {
                sameTitleColumns = await this.queryClient.fetchQuery(reservationColumnFindQueryOptions({
                    hospitalID: this.hospital.selectedHospital._id,
                    groupID: [groupID],
                    title: this.column.title,
                    isRemoved: false
                }))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 false 반환
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
                return false
            }

            for (let i = 0; i < sameTitleColumns.length; i++) {
                if (this.column._id != sameTitleColumns[i]._id) {
                    return true
                }
            }

            return false
        },
        isDuplicateTimes(array) {
            const filterArray = [...new Set(array)]
            return array.length != filterArray.length
        },
        // MARK: - Actions
        action_ChangeTab(isAppReservationSettingTab) {
            this.isAppReservationSettingTab = isAppReservationSettingTab
        },
        action_Close() {
            hideColumnSetting()
        },
        async action_Save() {
            if (await this.validate() == false) {
                return
            }
            this.isLoading = true
            try {
                if (this.isCreate == true) {
                    await this.createColumn()
                } else {
                    await this.updateColumn()
                }
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 중단
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
                return
            } finally {
                this.isLoading = false
            }

            if (this.sheetOverlays.columnSettingHandler != undefined) {
                await this.sheetOverlays.columnSettingHandler()
            }

            hideColumnSetting()
        },
        action_Remove() {
            showAlertPopup('AlertColumnRemoveConfirm', this.handleRemoveColumnLeft, this.handleRemoveColumnRight)
        },

        // MARK: - Alert Handle
        handleRemoveColumnLeft() {
            closeAlertPopup()
        },
        async handleRemoveColumnRight() {
            this.isLoading = true
            try {
                await this.removeColumn()
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 중단
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
                return
            } finally {
                this.isLoading = false
            }
            if (this.sheetOverlays.columnSettingHandler != undefined) {
                await this.sheetOverlays.columnSettingHandler()
            }
            closeAlertPopup()
            hideColumnSetting()
        },

        // MARK: - Network
        async loadData() {
            this.isLoading = true
            await this.loadUsers()
            await this.loadPrograms()
            await this.loadEmployees()
            this.isLoading = false
        },
        async loadUsers() {
            let hospitalID = this.hospital.selectedHospital._id
            let model = {
                hospitalID: hospitalID,
                isLeave: false
            }
            try {
                this.users = await this.queryClient.fetchQuery(hospitalAccountFindQueryOptions(model))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남긴다
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
            }
        },
        async loadPrograms() {
            let hospitalID = this.hospital.selectedHospital._id

            try {
                this.programs = await this.queryClient.fetchQuery(v2ReservationProgramListQueryOptions(hospitalID))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남긴다
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
            }
        },
        async loadEmployees() {
            let hospitalID = this.hospital.selectedHospital._id

            try {
                this.employees = await this.queryClient.fetchQuery(v2EmployeeListQueryOptions(hospitalID))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남긴다
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
            }
        },
        async createColumn() {
            let model = deepCopy(this.column)
            model.hospitalID = this.hospital.selectedHospital._id
            let newColumn = await this.createReservationColumn(model)
            newColumn.isSelected = true
            let columns = this.sheetFilters.columns.filter(c => c.groupID == this.column.groupID)

            let oldColumn = columns.find(c => c._id == newColumn._id)
            if (oldColumn != undefined) {
                let index = columns.indexOf(oldColumn)
                columns.splice(index, 1)
            }
            columns.splice(this.column.order, 0, newColumn)
            columns.forEach((g, index) => {
                g.order = index
            })

            let data = {
                hospitalID: this.hospital.selectedHospital._id,
                columns: columns
            }
            saveColumns(data)
        },
        async updateColumn() {
            let model = deepCopy(this.column)
            await this.updateReservationColumn(model)
        },
        async removeColumn() {
            let model = { _id: this.column._id }
            await this.removeReservationColumn(model)
        },
        updateValue(data) {
            let key = data.key
            let value = data.value
            this.column[key] = value
        },
        clearError(errorName) {
            this[errorName] = false
        }
    }
}
</script>